import api from './api';

export const vendorService = {
  getVendors: async (search = '') => {
    const query = search ? `?search=${encodeURIComponent(search)}` : '';
    return api.get(`/vendors${query}`);
  },

  getVendor: async (id) => {
    return api.get(`/vendors/${id}`);
  },

  createVendor: async (name) => {
    return api.post('/vendors', { name });
  },

  updateVendor: async (id, data) => {
    return api.put(`/vendors/${id}`, data);
  },

  deleteVendor: async (id) => {
    return api.delete(`/vendors/${id}`);
  },

  markAsRead: async (id) => {
    return api.put(`/vendors/${id}/mark-read`, {});
  },

  getMessages: async (vendorId) => {
    return api.get(`/messages/vendor/${vendorId}`);
  },

  createMessage: async (messageData) => {
    return api.post('/messages', messageData);
  },

  deleteMessage: async (id) => {
    return api.delete(`/messages/${id}`);
  }
};